import React from "react";
import SignInLayer from "../components/SignInLayer";

const SignInPage = ({ setSession }) => {
  return (
    <>

      {/* SignInLayer */}
      <SignInLayer setSession={setSession} />

    </>
  );
};

export default SignInPage; 
